import { render } from "./ReferenceCardsList.vue?vue&type=template&id=be14b7bc&scoped=true"
import script from "./ReferenceCardsList.vue?vue&type=script&lang=js"
export * from "./ReferenceCardsList.vue?vue&type=script&lang=js"

import "./ReferenceCardsList.vue?vue&type=style&index=0&id=be14b7bc&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be14b7bc"]])

export default __exports__